export default {
    word: {
        hello: 'hello',
        voices: 'voices',
        fans: 'fans',
        amounts: 'amounts',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js